// TODO while file can be deleted in future - https://qbe-appservices.atlassian.net/browse/AD1-562

import GlobalStyles from '@mui/material/GlobalStyles';
import React from 'react';

// TODO - Font assets may be uploaded to Sitecore instead of being local assets
import InterBoldWoff from './assets/Inter-Bold.woff';
import InterBoldWoff2 from './assets/Inter-Bold.woff2';
import InterBoldItalicWoff from './assets/Inter-BoldItalic.woff';
import InterBoldItalicWoff2 from './assets/Inter-BoldItalic.woff2';
import InterItalicWoff from './assets/Inter-Italic.woff';
import InterItalicWoff2 from './assets/Inter-Italic.woff2';
import InterMediumWoff from './assets/Inter-Medium.woff';
import InterMediumWoff2 from './assets/Inter-Medium.woff2';
import InterMediumItalicWoff from './assets/Inter-MediumItalic.woff';
import InterMediumItalicWoff2 from './assets/Inter-MediumItalic.woff2';
import InterRegularWoff from './assets/Inter-Regular.woff';
import InterRegularWoff2 from './assets/Inter-Regular.woff2';
import InterSemiBoldWoff from './assets/Inter-SemiBold.woff';
import InterSemiBoldWoff2 from './assets/Inter-SemiBold.woff2';
import InterSemiBoldItalicWoff from './assets/Inter-SemiBoldItalic.woff';
import InterSemiBoldItalicWoff2 from './assets/Inter-SemiBoldItalic.woff2';
import StagBoldWoff from './assets/StagBold.woff';
import StagBoldWoff2 from './assets/StagBold.woff2';
import StagMediumWoff from './assets/StagMedium.woff';
import StagMediumWoff2 from './assets/StagMedium.woff2';

const LoadInter = () => (
  <>
    <GlobalStyles
      styles={{
        '@font-face': {
          fontFamily: 'Inter',
          fontStyle: 'normal',
          fontWeight: 400,
          // TODO - can be optimised to use dynamic imports if this file scales
          src: `url(${InterRegularWoff2}) format('woff2'),
    url(${InterRegularWoff}) format('woff')`,
        },
      }}
    />
    <GlobalStyles
      styles={{
        '@font-face': {
          fontFamily: 'Inter',
          fontStyle: 'italic',
          fontWeight: 400,
          src: `url(${InterItalicWoff2}) format('woff2'),
    url(${InterItalicWoff}) format('woff')`,
        },
      }}
    />
    <GlobalStyles
      styles={{
        '@font-face': {
          fontFamily: 'Inter',
          fontStyle: 'italic',
          fontWeight: 500,
          src: `url(${InterMediumWoff2}) format('woff2'),
    url(${InterMediumWoff}) format('woff')`,
        },
      }}
    />
    <GlobalStyles
      styles={{
        '@font-face': {
          fontFamily: 'Inter',
          fontStyle: 'normal',
          fontWeight: 500,
          src: `url(${InterMediumWoff2}) format('woff2'),
    url(${InterMediumWoff}) format('woff')`,
        },
      }}
    />
    <GlobalStyles
      styles={{
        '@font-face': {
          fontFamily: 'Inter',
          fontStyle: 'italic',
          fontWeight: 500,
          src: `url(${InterMediumItalicWoff2}) format('woff2'),
    url(${InterMediumItalicWoff}) format('woff')`,
        },
      }}
    />
    <GlobalStyles
      styles={{
        '@font-face': {
          fontFamily: 'Inter',
          fontStyle: 'normal',
          fontWeight: 600,
          src: `url(${InterSemiBoldWoff2}) format('woff2'),
    url(${InterSemiBoldWoff}) format('woff')`,
        },
      }}
    />
    <GlobalStyles
      styles={{
        '@font-face': {
          fontFamily: 'Inter',
          fontStyle: 'italic',
          fontWeight: 600,
          src: `url(${InterSemiBoldItalicWoff2}) format('woff2'),
    url(${InterSemiBoldItalicWoff}) format('woff')`,
        },
      }}
    />
    <GlobalStyles
      styles={{
        '@font-face': {
          fontFamily: 'Inter',
          fontStyle: 'normal',
          fontWeight: 700,
          src: `url(${InterBoldWoff2}) format('woff2'),
    url(${InterBoldWoff}) format('woff')`,
        },
      }}
    />
    <GlobalStyles
      styles={{
        '@font-face': {
          fontFamily: 'Inter',
          fontStyle: 'italic',
          fontWeight: 700,
          src: `url(${InterBoldItalicWoff2}) format('woff2'),
    url(${InterBoldItalicWoff}) format('woff')`,
        },
      }}
    />
  </>
);

const LoadStag = () => (
  <>
    <GlobalStyles
      styles={{
        '@font-face': {
          fontFamily: 'Stag',
          fontStyle: 'normal',
          fontWeight: 500,
          src: `url(${StagMediumWoff2}) format('woff2'),
          url(${StagMediumWoff}) format('woff')`,
        },
      }}
    />
    <GlobalStyles
      styles={{
        '@font-face': {
          fontFamily: 'Stag',
          fontStyle: 'normal',
          fontWeight: 700,
          src: `url(${StagBoldWoff2}) format('woff2'),
          url(${StagBoldWoff}) format('woff')`,
        },
      }}
    />
  </>
);

export const LoadQBEThemeFonts = () => (
  <>
    <LoadInter />
    <LoadStag />
  </>
);
